/**
 * LLD Problem filtering utilities.
 * Pure functions for filtering problems by difficulty and/or category.
 */

export type Difficulty = 'Beginner' | 'Intermediate' | 'Advanced' | 'Expert';

export type Category =
 | 'Object Modeling'
 | 'System Management'
 | 'Payment and Splitting'
 | 'Booking and Reservation'
 | 'Real-Time Services';

export interface LLDProblem {
 id: string;
 title: string;
 difficulty: Difficulty;
 category: Category;
 description: string;
 isCompleted: boolean;
}

export interface ProblemFilters {
 difficulty?: Difficulty;
 category?: Category;
}

/**
 * Filters problems by difficulty and/or category.
 * If no filters are set, returns all problems.
 * If both filters are set, returns only problems matching both criteria.
 *
 * @param problems - The full list of LLD problems
 * @param filters - Optional difficulty and/or category filters
 * @returns Filtered array of problems matching all active filter criteria
 */
export function filterProblems(
 problems: LLDProblem[],
 filters: ProblemFilters
): LLDProblem[] {
 return problems.filter((problem) => {
  if (filters.difficulty && problem.difficulty !== filters.difficulty) {
   return false;
  }
  if (filters.category && problem.category !== filters.category) {
   return false;
  }
  return true;
 });
}
